import { MARQUEE } from "@/lib/brand";

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 py-6 sm:py-8">
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-display text-3xl sm:text-5xl font-bold tracking-tight px-6 sm:px-10 ${i % 2 ? "outline-num" : "text-white/90"}`}>{t}</span>
            <span className="h-2.5 w-2.5 rotate-45 grad-bg" />
          </span>
        ))}
      </div>
    </div>
  );
};
